import {
  EDIT_WEDDING_HALL_PATH_A,
  HOTEL_MENU_CREATE_PATH_A
} from '@components/Hotel/constant'
import {
  ACTIVITY_DIY_PATH_A,
  ALBUM_MANAGE_PATH_A,
  APPRAISE_LIST_PATH_A,
  // MARKETING_PRODUCT_DETAIL_PATH_A
  CASE_MANAGE_PATH_A,
  CONTENT_CENTER_CREATION_PATH_A,
  COUPONS_PATH_A,
  CUSTOMER_MANAGE_LIST_PATH_A,
  DECORATION_PATH_A,
  DELIVER_MOUDLE_PATH_A,
  DYNAMIC_PATH_A,
  INCOME_PATH_A,
  JIAMENG_GOODS_PATH_A,
  LIVE_MANAGE_PATH_A,
  MATERIAL_PATH_ADD_A,
  NAME_CARD_MANAGE_PATH_A,
  PUBLISH_CASE_PATH_A,
  PUBLISH_MEAL_PATH_A,
  PUBLISH_STYLE_PATH_A,
  SCHEDULETOOL_PATH_A,
  SETMEAL_PATH_A,
  STUFF_ACCOUNT_MANAGE_PATH_A,
  ZGT_PATH_A
} from '@constant'
import { isHotelProperty } from '@merchant-backend/util'
import { getMerchantInfo } from '@util'

export default {
  decoration: {
    // 主页装修
    path: DECORATION_PATH_A,
    icon: 'icon-tasklist_fill'
  },
  package: {
    // 发布套餐
    path: PUBLISH_MEAL_PATH_A,
    icon: 'icon-order_fill'
  },
  package_manage: {
    // 套餐管理
    path: SETMEAL_PATH_A,
    icon: 'icon-order_fill'
  },
  case: {
    // 发布案例
    path: PUBLISH_CASE_PATH_A,
    icon: ''
  },
  style: {
    // 发布款式
    path: PUBLISH_STYLE_PATH_A,
    icon: ''
  },
  case_manage: {
    // 案例管理
    path: CASE_MANAGE_PATH_A,
    icon: ''
  },
  dynamic: {
    // 发动态
    path: () => {
      const propertyId = getMerchantInfo().property_id
      if (
        propertyId == 2 ||
        propertyId == 6 ||
        propertyId == 12 ||
        isHotelProperty()
      ) {
        // 婚礼策划、婚纱摄影、婚纱礼服、酒店
        return CONTENT_CENTER_CREATION_PATH_A
      } else {
        return DYNAMIC_PATH_A
      }
    },
    icon: 'icon-picture_fill'
  },
  dynamic_manage: {
    // 动态管理
    path: () => {
      const propertyId = getMerchantInfo().property_id
      if (
        propertyId == 2 ||
        propertyId == 6 ||
        propertyId == 12 ||
        isHotelProperty()
      ) {
        // 婚礼策划、婚纱摄影、婚纱礼服、酒店
        return CONTENT_CENTER_CREATION_PATH_A
      } else {
        return DYNAMIC_PATH_A
      }
    },
    icon: 'icon-picture_fill'
  },
  haicaoCard: {
    // 海草名片
    path: NAME_CARD_MANAGE_PATH_A,
    icon: 'icon-addressbook_fill'
  },
  miniLeaflet: {
    // 微传单+
    path: ACTIVITY_DIY_PATH_A,
    icon: ''
  },
  invitation: {
    // 电子请帖
    path: DELIVER_MOUDLE_PATH_A,
    icon: 'icon-coupons_fill'
  },
  customer: {
    // 客资列表
    path: CUSTOMER_MANAGE_LIST_PATH_A,
    icon: 'icon-group_fill'
  },
  album: {
    // 传相册
    path: ALBUM_MANAGE_PATH_A,
    icon: 'icon-xiangce'
  },
  hall: {
    // 传场地
    path: EDIT_WEDDING_HALL_PATH_A,
    icon: 'icon-changdi'
  },
  menu: {
    // 传菜单
    path: HOTEL_MENU_CREATE_PATH_A,
    icon: 'icon-caidan'
  },
  live: {
    // 视频直播
    path: LIVE_MANAGE_PATH_A,
    icon: 'icon-live_fill'
  },
  coupon: {
    // 优惠券
    path: COUPONS_PATH_A,
    icon: 'icon-coupons_fill'
  },
  zhiGuangTong: {
    // 智优投
    path: ZGT_PATH_A,
    icon: ''
  },
  calendar: {
    // 建档期
    path: SCHEDULETOOL_PATH_A,
    icon: 'icon-dangqiguanli'
  },
  material: {
    // 发创意
    path: MATERIAL_PATH_ADD_A,
    icon: ''
  },
  product_management: {
    // 加盟店商品管理
    path: JIAMENG_GOODS_PATH_A,
    icon: ''
  },
  income_management: {
    // 加盟店商品管理
    path: INCOME_PATH_A,
    icon: ''
  },
  customer_service_management: {
    // 加盟店多客服管理
    path: STUFF_ACCOUNT_MANAGE_PATH_A,
    icon: ''
  },
  comment_manage: {
    // 评价管理
    path: APPRAISE_LIST_PATH_A,
    icon: ''
  }
}
